import React from "react";
import { Modal, Button as BootstrapButton } from "react-bootstrap";
import { DirectionIcon } from "./CountryCodeDirectionPicker";

const CountryCodeDirectionsModal = ({
    show,
    onHide,
    title = "Country Codes",
    ownerLabel = "Owner",
    ownerName = "",
    directions = [],
}) => {
    return (
        <Modal show={show} onHide={onHide} centered dialogClassName="cc-direction-modal">
            <style>
                {`
                .cc-direction-modal .modal-dialog { max-width: 480px !important; }
                .cc-direction-modal .modal-content { border-radius: 14px !important; overflow: hidden; box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important; }
                .cc-direction-modal .modal-header { background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important; color: white !important; border-bottom: none !important; border-radius: 14px 14px 0 0 !important; padding: 18px 24px !important; }
                .cc-direction-modal .modal-title { color: white !important; font-size: 20px !important; font-weight: 600 !important; margin: 0 !important; }
                .cc-direction-modal .btn-close { filter: brightness(0) invert(1) !important; opacity: 0.8 !important; }
                .cc-direction-modal .btn-close:hover { opacity: 1 !important; }
                .cc-direction-modal .modal-body { padding: 24px !important; }
                .cc-direction-row { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; font-size: 14px; padding: 8px 10px; border: 1px solid #e5e7eb; border-radius: 8px; }
                `}
            </style>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
                <button type="button" className="btn-close btn-close-white" onClick={onHide} aria-label="Close" />
            </Modal.Header>
            <Modal.Body>
                <div style={{ fontSize: "16px", fontWeight: 500, marginBottom: 16 }}>
                    {ownerLabel}: <span style={{ fontWeight: 400 }}>{ownerName}</span>
                </div>
                <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 12 }}>
                    Country Codes
                </div>
                {directions.length === 0 ? (
                    <div style={{ fontSize: 14 }}>No country codes assigned</div>
                ) : (
                    directions.map((d, idx) => {
                        const master = d.directionMaster || d;
                        const country = master?.country_code || {};
                        const callingCode = country?.calling_code ? `+${country.calling_code}` : "";
                        const enabled = master?.is_enabled !== false;
                        return (
                            <div key={idx} className="cc-direction-row">
                                <DirectionIcon size={18} />
                                <span style={{ fontWeight: 500 }}>{country?.name || "Unknown"}</span>
                                <span>{callingCode}</span>
                                <span style={{
                                    marginLeft: "auto",
                                    fontSize: 12,
                                    color: enabled ? "#16a34a" : "#9ca3af",
                                }}>
                                    {enabled ? "Enabled" : "Disabled"}
                                </span>
                            </div>
                        );
                    })
                )}
            </Modal.Body>
            <div style={{
                backgroundColor: "white",
                borderTop: "1px solid #e5e7eb",
                padding: "16px 24px",
                borderRadius: "0 0 14px 14px",
                display: "flex",
                justifyContent: "flex-end",
            }}>
                <BootstrapButton
                    onClick={onHide}
                    style={{
                        padding: "8px 22px",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: 14,
                        fontWeight: 500,
                        color: "white",
                        background: "linear-gradient(135deg, #4f6edb, #3b5ccc)",
                        boxShadow: "0 8px 18px rgba(79,110,219,0.35)",
                    }}
                >
                    Close
                </BootstrapButton>
            </div>
        </Modal>
    );
};

export default CountryCodeDirectionsModal;
